module.exports = __webpack_public_path__ + "img/logo.a21b14cf.png";